import { DataGridFilters } from "fe-shared/src/components/DataGrid/modules/types";
import { BusinessRole } from "fe-shared/src/types/domain";
import { TransactionType } from "../types";
import { getTransactionTypes } from "./transactionsGridConfig";

export interface FilterQuery {
  from: string;
  to: string;
  transactionType: string;
  participantRegNumber: string;
  invoiceNumber: string;
}

export const parseQuery = (search: string) => {
  const urlParams = new URLSearchParams(search);

  return Object.fromEntries(urlParams);
};

const getTransactionTypeFilter = (
  transactionType: string,
  businessRoleCode?: BusinessRole
) =>
  Object.values(TransactionType).includes(transactionType as TransactionType)
    ? [transactionType]
    : getTransactionTypes(businessRoleCode).filter(
        (t) => t !== TransactionType.Adjustment
      );

export const getTransactionsFilterParams = (
  search: string,
  businessRoleCode?: BusinessRole
): DataGridFilters => {
  const parsedQuery = parseQuery(search) as Partial<FilterQuery>;
  const {
    from,
    to,
    transactionType,
    participantRegNumber,
    invoiceNumber,
  } = parsedQuery;

  return {
    ...(from && to
      ? {
          completedDate: {
            type: "dateRangeFilter",
            value: [from, to],
          },
        }
      : {}),
    ...(transactionType
      ? {
          transactionType: {
            type: "selectFilter",
            value: getTransactionTypeFilter(transactionType, businessRoleCode),
          },
        }
      : {}),
    ...(participantRegNumber
      ? {
          participants: {
            type: "textFilter",
            value: participantRegNumber,
          },
        }
      : {}),
    ...(invoiceNumber
      ? {
          transactionNumber: {
            type: "textFilter",
            value: invoiceNumber,
          },
        }
      : {}),
  };
};

export const getTransfersFilterParams = (search: string): DataGridFilters => {
  const parsedQuery = parseQuery(search) as Partial<FilterQuery>;
  const { invoiceNumber } = parsedQuery;

  return {
    ...(invoiceNumber
      ? {
          transferNumber: {
            type: "textFilter",
            value: invoiceNumber,
          },
        }
      : {}),
  };
};
